import { render } from "./ProductCardMedia.vue?vue&type=template&id=5217b122&scoped=true"
import script from "./ProductCardMedia.vue?vue&type=script&lang=js"
export * from "./ProductCardMedia.vue?vue&type=script&lang=js"

import "./ProductCardMedia.vue?vue&type=style&index=0&id=5217b122&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5217b122"]])

export default __exports__